/**
 * The one process-step → illustration mapping, shared by the landing Process
 * section and the "How we work" mega menu so both always show the same art
 * for a step.
 */
import type { ComponentType } from "react";
import { processStepKeys } from "@/lib/brand";
import { ScopeIllustration } from "./ScopeIllustration";
import { BuildIllustration } from "./BuildIllustration";
import { ShipIllustration } from "./ShipIllustration";

export const processStepIllustrations: Record<
  (typeof processStepKeys)[number],
  ComponentType
> = {
  scope: ScopeIllustration,
  build: BuildIllustration,
  ship: ShipIllustration,
};
